import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AgreementPageLayerProps } from 'components/AgreementPdfViewer';
import { pointsToPixels } from 'agreementCoordinatesUtils';
import { getAgreementFieldLabel } from 'agreementUtils';
import AgreementFieldsPreviewContext from '../../AgreementFieldsPreview.context';
import classNames from 'classnames';

import './ReadOnlyFieldsLayer.styles.scss';

const BASE_FONT_SIZE = 11;

const ReadOnlyFieldsLayer: React.FC<AgreementPageLayerProps> = (props) => {
  const { pageNumber, scale } = props;

  const { fields } = useContext(AgreementFieldsPreviewContext);

  const { t } = useTranslation();

  const pageFields = useMemo(
    () => fields.filter(({ page }) => page === pageNumber),
    [fields, pageNumber],
  );

  return (
    <div
      className="read-only-fields-layer"
      style={{ fontSize: BASE_FONT_SIZE * scale }}
    >
      {pageFields.map((field) => {
        const { x, y, width, height } = pointsToPixels(field, scale);

        return (
          <span
            key={field.id}
            className={classNames(
              'read-only-fields-layer__field',
              `read-only-fields-layer__field--${field.type}`,
            )}
            style={{ left: x, top: y, width, height }}
          >
            {getAgreementFieldLabel(field, t)}
          </span>
        );
      })}
    </div>
  );
};

export default ReadOnlyFieldsLayer;
